import { createStyles, makeStyles } from '@hawkins/styles';
export var timePickerDropdownStyles = function () {
    return createStyles({
        /** Class name to apply to the root of the component (the dropdown trigger) */
        root: {
            minWidth: 184,
        },
        /** Class name to apply to the root of the component when it is full-width */
        rootFullWidth: {
            width: '100%',
        },
        /** Class name to apply to the start adornment icon */
        startAdornmentIcon: {
            marginTop: 1,
        },
    });
};
export var useTimePickerDropdownStyles = makeStyles(timePickerDropdownStyles(), {
    name: 'Hawkins-TimePickerDropdown',
});
